import { translations, getLangFromURL } from '../map/i18n.js';
import { UI_IDS } from '../map/config.js';

export class UIController {
    constructor(pano) {
        this.pano = pano;
        this.lang = getLangFromURL('el');
        this.t = translations[this.lang];
        
        const urlParams = new URLSearchParams(window.location.search);
        
        this.isThumbnailsActive = false;
        this.isMapActive = false;
        // Default to true, unless specified as false in the URL 
        // e.g., ?vis_accessibility=false
        this.isWheelmapActive = urlParams.get('vis_accessibility') !== 'false';
    }

    init() {
        this.injectHTML();
        this.attachEvents();
        setTimeout(() => {
            this.setGlobalLanguage(this.lang);
        }, 100); // Give the DOM and pano engine a moment to load
        this.syncInitialStates(); // Load initial toggle states dynamically
    }

    setGlobalLanguage(lang) {
        this.setLanguage(lang);
                
        if (window.mapOverlay && typeof window.mapOverlay.setLanguage === 'function') {
            window.mapOverlay.setLanguage(lang);
        }
        
        if (window.timelineController && typeof window.timelineController.setLanguage === 'function') {
            window.timelineController.setLanguage(lang);
        }
        
        // Set language internally in pano engine
        if (this.pano && typeof this.pano.setLanguage === 'function') {
            this.pano.setLanguage(lang);
        }
        
        if (this.pano && typeof this.pano.setVariableValue === 'function') {
            this.pano.setVariableValue('var_lang', lang); 
        }
    }

    syncInitialStates() {
        const btnWheelmap = document.getElementById('btn-wheelmap');
        if (btnWheelmap) {
            btnWheelmap.classList.toggle('active', this.isWheelmapActive);
            // Ensure pano engine starts perfectly synced
            if (this.pano && typeof this.pano.setVariableValue === 'function') {
                this.pano.setVariableValue('vis_accessibility', this.isWheelmapActive);
            }
        }
    }

    injectHTML() {
        if (document.getElementById('uoc-toolbar')) return;

        const dockHTML = `
        <div class="uoc-dock" id="uoc-toolbar">
            
            <!-- Campus Selector -->
            <div class="campus-menu-container">
                <button class="uoc-btn" id="btn-campus" title="Select Campus">
                    <i class="ph ph-map-pin"></i>
                    <span class="uoc-btn-label" id="current-campus-label">Βούτες</span>
                    <i class="ph ph-caret-up" style="font-size: 0.9rem; margin-left: 4px;"></i>
                </button>
                
                <div class="campus-dropdown" id="campus-dropdown">
                    <button class="campus-option selected" data-campus="voutes">
                        <i class="ph ph-buildings"></i> Βούτες (Ηράκλειο)
                    </button>
                    <button class="campus-option" data-campus="gallos">
                        <i class="ph ph-tree-evergreen"></i> Γάλλος (Ρέθυμνο)
                    </button>
                    
                    <div class="nested-menu-wrapper">
                        <button class="campus-option has-submenu" id="btn-other-locations">
                            <i class="ph ph-star"></i> Άλλες Τοποθεσίες
                            <i class="ph ph-caret-down" id="other-caret" style="margin-left: auto; font-size: 0.8rem;"></i>
                        </button>
                        <div class="campus-submenu" id="campus-submenu">
                            <button class="campus-option sub-option" data-campus="edu-museum">Μουσείο της Εκπαίδευσης</button>
                            <button class="campus-option sub-option" data-campus="culture-house">Σπίτι του Πολιτισμού</button>
                            <button class="campus-option sub-option" data-campus="eleutherna">Αρχαία Ελεύθερνα</button>
                            <button class="campus-option sub-option" data-campus="skinakas">Αστεροσκοπείο Σκίνακα</button>
                            <button class="campus-option sub-option" data-campus="finokalias">Σταθμός Φινοκαλιά</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="uoc-divider"></div>

            <!-- Thumbnails and Map Overlays -->
            <button class="uoc-btn icon-only" id="btn-thumbnails" title="Show Thumbnails">
                <i class="ph ph-squares-four"></i>
            </button>
            <button class="uoc-btn icon-only" id="btn-open-map" title="Open Map">
                <i class="ph ph-map-trifold"></i>
            </button>

            <div class="uoc-divider"></div>

            <!-- Wheelmap Toggle -->
            <button class="uoc-btn icon-only uoc-btn-wheelmap" id="btn-wheelmap" title="Wheelmap (Accessibility Layers)">
                <i class="ph ph-wheelchair"></i>
            </button>

            <div class="uoc-divider"></div>

            <!-- Utility Buttons -->
            <button class="uoc-btn icon-only" id="btn-new-tab" title="Open in a New Tab">
                <i class="ph ph-arrow-square-out"></i>
            </button>

            <div class="uoc-divider"></div>

            <!-- Language Toggle -->
            <button class="uoc-btn icon-only" id="btn-lang" title="Switch Language">
                <span class="uoc-lang-text" id="lang-label">EN</span>
            </button>

        </div>`;
        document.body.insertAdjacentHTML('beforeend', dockHTML);
    }

    attachEvents() {
        // 1. Thumbnails Logic (Pano2VR Binding)
        const btnThumbnails = document.getElementById('btn-thumbnails');
        if (btnThumbnails) {
            btnThumbnails.addEventListener('click', () => {
                this.isThumbnailsActive = !this.isThumbnailsActive;
                btnThumbnails.classList.toggle('active', this.isThumbnailsActive);
                console.log('Action: Toggle Thumbnails Bar', this.isThumbnailsActive);
                
                if (this.pano && typeof this.pano.setVariableValue === 'function') {
                    this.pano.setVariableValue('vis_thumbnails', this.isThumbnailsActive);
                    this.pano.setVariableValue('vis_thumbnails_phone', this.isThumbnailsActive);
                }
            });
        }

        // 2. Map Modal Logic (Integration with MapComponent modal)
        const btnOpenMap = document.getElementById('btn-open-map');
        if (btnOpenMap) {
            btnOpenMap.addEventListener('click', () => {
                this.isMapActive = !this.isMapActive;
                btnOpenMap.classList.toggle('active', this.isMapActive);
                
                const modal = document.getElementById(UI_IDS.modalId);
                if (modal) {
                    if (this.isMapActive) {
                        modal.classList.remove('hidden');
                        if(window.mapOverlay && window.mapOverlay.map) {
                            setTimeout(() => {
                                window.mapOverlay.map.invalidateSize();
                                window.mapOverlay.events.updateCurrentNodeMapVisibility();
                            }, 200);
                        }
                    } else {
                        modal.classList.add('hidden');
                    }
                }
            });
        }

        // 3. Wheelmap Logic (Stubbed for future expansion)
        const btnWheelmap = document.getElementById('btn-wheelmap');
        if (btnWheelmap) {
            btnWheelmap.addEventListener('click', () => {
                this.isWheelmapActive = !this.isWheelmapActive;
                btnWheelmap.classList.toggle('active', this.isWheelmapActive);
                console.log('Action: Wheelmap Layers Toggled', this.isWheelmapActive);
                
                if (this.pano && typeof this.pano.setVariableValue === 'function') {
                    this.pano.setVariableValue('vis_accessibility', this.isWheelmapActive);
                }
                
                this.toggleWheelmapLayers(this.isWheelmapActive);
            });
        }

        // 5. Open new tab Logic
        const btnNewTab = document.getElementById('btn-new-tab');
        if (btnNewTab) {
            btnNewTab.addEventListener('click', () => {
                let ucnode = '';
                let ap = 0;
                let at = 0;
                let af = 70;
                
                if (this.pano) {
                    const currentNode = this.pano.getCurrentNode();
                    const userData = this.pano.getNodeUserdata(currentNode);
                    ucnode = userData && userData.customnodeid ? userData.customnodeid : currentNode;
                    ap = (this.pano.getPan() || 0).toFixed(2);
                    at = (this.pano.getTilt() || 0).toFixed(2);
                    af = (this.pano.getFov() || 70).toFixed(2);
                }
                
                const url = `https://pr.uoc.gr/virtualtour/#${ucnode},${ap},${at},${af}`;
                window.open(url, '_blank');
            });
        }

        // 6. Global Language Setup
        const btnLang = document.getElementById('btn-lang');
        if (btnLang) {
            btnLang.addEventListener('click', () => {
                const newLang = this.lang === 'el' ? 'en' : 'el';
                this.setGlobalLanguage(newLang);
            });
        }
        
        // 7. Campus Switching Dropdown
        this.attachCampusMenuEvents();

        // 8. Auto-update location on panorama change
        if (this.pano && typeof this.pano.on === 'function') {
            this.pano.on('changenode', () => {
                this.updateCampusOnNodeChange();
                
                // Force map button deactivation if map closes automatically
                if (this.isMapActive) {
                    this.isMapActive = false;
                    const btnOpenMap = document.getElementById('btn-open-map');
                    if (btnOpenMap) btnOpenMap.classList.remove('active');
                }
            });
        }
    }

    updateCampusOnNodeChange() {
        if (!this.pano) return;
        
        const currentNode = this.pano.getCurrentNode();
        const userData = this.pano.getNodeUserdata(currentNode);
        
        if (!userData || !userData.tags) return;
        
        const tags = Array.isArray(userData.tags) ? userData.tags : String(userData.tags).split(/[\s,]+/);
        
        const reverseTagMap = {
            'voutes': 'voutes',
            'gallos': 'gallos',
            'eleutherna': 'eleutherna',
            'education': 'edu-museum',
            'skinakas': 'skinakas',
            'finokalias': 'finokalias'
        };

        for (const tag of tags) {
            if (reverseTagMap[tag]) {
                const locationId = reverseTagMap[tag];
                
                // Update specific button active states
                const campusOptions = document.querySelectorAll('.campus-option:not(.has-submenu)');
                campusOptions.forEach(opt => opt.classList.remove('selected'));
                
                const selectedOpt = document.querySelector(`.campus-option[data-campus="${locationId}"]`);
                if (selectedOpt) {
                    selectedOpt.classList.add('selected');
                }
                
                this.updateCampusLabel(locationId);
                break; // Stop after first matched tag
            }
        }
    }

    toggleWheelmapLayers(isActive) {
        // Stub implementation
        // map.addLayer() / removeLayer() hooks go here.
    }

    attachCampusMenuEvents() {
        const btnCampus = document.getElementById('btn-campus');
        const campusDropdown = document.getElementById('campus-dropdown');
        const campusOptions = document.querySelectorAll('.campus-option:not(.has-submenu)');
        const btnOtherLocations = document.getElementById('btn-other-locations');
        const campusSubmenu = document.getElementById('campus-submenu');
        const otherCaret = document.getElementById('other-caret');

        if (btnCampus) {
            btnCampus.addEventListener('click', (e) => {
                e.stopPropagation();
                campusDropdown.classList.toggle('show');
            });
        }

        if (btnOtherLocations) {
            btnOtherLocations.addEventListener('click', (e) => {
                e.stopPropagation();
                campusSubmenu.classList.toggle('show');
                otherCaret.classList.toggle('ph-caret-up');
                otherCaret.classList.toggle('ph-caret-down');
            });
        }

        // Close on outside click
        document.addEventListener('click', () => {
            if(campusDropdown && campusDropdown.classList.contains('show')) {
                campusDropdown.classList.remove('show');
                if(campusSubmenu) campusSubmenu.classList.remove('show');
                if(otherCaret) {
                    otherCaret.classList.add('ph-caret-down');
                    otherCaret.classList.remove('ph-caret-up');
                }
            }
        });

        // Trigger campus select
        campusOptions.forEach(option => {
            option.addEventListener('click', (e) => {
                e.stopPropagation();
                
                campusOptions.forEach(opt => opt.classList.remove('selected'));
                option.classList.add('selected');
                
                const selectedCampus = option.getAttribute('data-campus');
                this.updateCampusLabel(selectedCampus);

                campusDropdown.classList.remove('show');
                if(campusSubmenu) campusSubmenu.classList.remove('show');
                if(otherCaret) {
                    otherCaret.classList.add('ph-caret-down');
                    otherCaret.classList.remove('ph-caret-up');
                }

                this.flyToLocation(selectedCampus);
            });
        });
    }

    flyToLocation(locationId) {
        console.log(`Action: Fly to Campus/Location - ${locationId}`);
        
        if (!this.pano) return;

        const tagMap = {
            'voutes': 'voutes',
            'gallos': 'gallos',
            'eleutherna': 'eleutherna',
            'edu-museum': 'education',
            'skinakas': 'skinakas',
            'finokalias': 'finokalias'
        };

        const targetTag = tagMap[locationId];
        
        if (targetTag && typeof this.pano.getNodeIds === 'function') {
            const nodeIds = this.pano.getNodeIds();
            const targetNodeId = nodeIds.find(id => {
                const userData = this.pano.getNodeUserdata(id);
                if (userData && userData.tags) {
                    // tags could be an array or space-separated string depending on engine version,
                    // handle safely by ensuring it's an array for includes
                    const tags = Array.isArray(userData.tags) ? userData.tags : String(userData.tags).split(/[\s,]+/);
                    return tags.includes(targetTag);
                }
                return false;
            });

            if (targetNodeId) {
                console.log(`Matched tag '${targetTag}' to node '${targetNodeId}'`);
                // Using exact ID string or wrapped {id} string based on Pano2VR variable mapping standard
                this.pano.openNext('{' + targetNodeId + '}');
            } else {
                console.warn(`No node found with tag '${targetTag}'`);
            }
        }
    }

    setLanguage(lang) {
        if (!translations[lang]) lang = 'el';
        this.lang = lang;
        this.t = translations[lang];
        this.updateUITexts();
    }

    updateUITexts() {
        if (!this.t || !this.t.dock) return;
        const dockT = this.t.dock;
        
        // 1. Map current selected button text label
        const selectedOption = document.querySelector('.campus-option.selected');
        if (selectedOption) {
            this.updateCampusLabel(selectedOption.getAttribute('data-campus'));
        }

        // 2. Language Switcher Button Text 
        const langLabelBtn = document.getElementById('lang-label');
        if (langLabelBtn) {
            langLabelBtn.textContent = dockT.langLabel; 
        }

        // 3. Dropdown Menu Items
        const updateOpt = (id, contents) => {
            const el = document.querySelector(`.campus-option[data-campus="${id}"]`);
            if (el) el.innerHTML = contents;
        };

        const updateOtherBtn = () => {
            const el = document.getElementById('btn-other-locations');
            if (el) {
                el.innerHTML = `<i class="ph ph-star"></i> ${dockT.otherLocs}
                <i class="ph ph-caret-down" id="other-caret" style="margin-left: auto; font-size: 0.8rem;"></i>`;
            }
        };

        updateOpt('voutes', `<i class="ph ph-buildings"></i> ${dockT.voutesFull}`);
        updateOpt('gallos', `<i class="ph ph-tree-evergreen"></i> ${dockT.gallosFull}`);
        updateOtherBtn();
        updateOpt('edu-museum', dockT.eduMuseumFull);
        updateOpt('culture-house', dockT.cultureHouseFull);
        updateOpt('eleutherna', dockT.eleuthernaFull);
        updateOpt('skinakas', dockT.skinakasFull);
        updateOpt('finokalias', dockT.finokaliasFull);
    }

    updateCampusLabel(campusId) {
        const campusLabelEl = document.getElementById('current-campus-label');
        if (!campusLabelEl || !this.t || !this.t.dock) return;

        const map = {
            'voutes': 'voutes',
            'gallos': 'gallos',
            'edu-museum': 'eduMuseum',
            'culture-house': 'cultureHouse',
            'eleutherna': 'eleutherna',
            'skinakas': 'skinakas',
            'finokalias': 'finokalias'
        };

        const key = map[campusId];
        if (key && this.t.dock[key]) {
            campusLabelEl.textContent = this.t.dock[key];
        }
    }
}